<template>
  <div class="animated fadeIn">
    <div class="row" >
      <div class="col-sm-12">
        <b-card body-class="bg-gray-100 ">
          <div slot="header"  ref="div-botoes">
            <i class='fa fa-align-justify'></i><strong>  PRODUÇÃO ORDEM DE ABATE  </strong> <small>Identificação Básicas</small>
            <div class="card-alinha" ref="linha-botoes">
              <b-button variant="outline-info"  type="button" @click.stop.prevent="$router.go(-1)" > 
                  <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
             
            </div>
          </div>
            <div class="row">
              <!--/.col-->
              <div class="col-sm-2">
                <b-form-fieldset label="Código ID">
                  <b-form-input type="text" id="edID" :disabled="true" placeholder="Código Automático" v-model="registro.ID"></b-form-input>
                </b-form-fieldset>
              </div>
            
              
              <!--/.col-->
              <div class="col-sm-2">
                <b-form-fieldset label="Data Cadastro">
                  <b-form-input  type="date" id="edDT_LANCAMENTO" :disabled="true" v-model="registro.DT_LANCAMENTO" placeholder="" > </b-form-input>
                </b-form-fieldset>
              </div>  
              <!--/.col-->
              <div class="col-sm-4">
                <b-form-fieldset label="Situação">
                  <b-form-input  type="text" id="edSituacao" :disabled="true" v-model="traduzStatus" placeholder="" > </b-form-input>
                </b-form-fieldset>
              </div>  
            </div>  
            
           
        </b-card>
        <b-card body-class="bg-gray-100 ">
          <div slot="header" >
            <i class='fa fa-align-justify'></i><strong>  BÁSICAS  </strong>
          </div>
            <b-row>
              <!--/.col-->
              <b-col sm="2">
                <b-form-fieldset label="Data do Resumo">
                  <b-form-input  type="date" id="edDT_LOTE" :disabled="true"  v-model="registro.DATA" :state="registro.DATA != null" placeholder="" > </b-form-input>
                </b-form-fieldset>
              </b-col>
              <!--/.col-->
              <b-col sm="3">
                <b-form-fieldset label="Tipo de Fechamento">
                  <b-form-select  :plain="true" 
                                  id="combotipoFechamento"
                                  :disabled="true"
                                  v-model="registro.OP_TIPO"
                                  :options="tipoFechamento">
                    </b-form-select>
                </b-form-fieldset>
              </b-col>
               <!--/.col-->
              <b-col sm="7">
                  <ordem-abate-fechada-pesquisa 
                                    @retornaId="registro.ABATE_ID = $event"
                                    :idInicial="registro.ABATE_ID"
                                    :desabilitarInput="true"
                                    idModal="ordemAbate"
                                    label="Ordem Abate Fechada"
                                    id="edABATE_ID"
                                    place="Informe a Ordem de Abate"
                                    labelBotao="">
                  </ordem-abate-fechada-pesquisa>
                </b-col>
            </b-row>
            
           
        </b-card>
        <b-row>
          <b-col sm="6">
            <b-card body-class="bg-gray-100">
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Interessados</strong>
              </div>
              <b-row>
                <b-col sm="12">
                  <funcionario-pesquisa 
                                    @retornaId="registro.BALANCEIRO_ID = $event"
                                    :idInicial="registro.BALANCEIRO_ID"
                                    :desabilitarInput="true"
                                    idModal="modalBalanceiro"
                                    label="Responsável"
                                    id="edBALANCEIRO_ID"
                                    place="Informe o Responsável"
                                    labelBotao="">
                  </funcionario-pesquisa>
              </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card body-class="bg-gray-100">
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Endereçamento</strong>
              </div>
              <b-row>
                <b-col sm="12">
                  <centro-estoque-pesquisa 
                                    @retornaId="registro.CENTRO_ESTOQUE_ID = $event"
                                    :idInicial="registro.CENTRO_ESTOQUE_ID"
                                    :desabilitarInput="true"
                                    idModal="modalCentroEstoqueDestino"
                                    label="Estoque de Destino"
                                    id="edCENTRO_ESTOQUE_ID"
                                    place="Informe Estoque de Destino"
                                    labelBotao="">
                  </centro-estoque-pesquisa>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-card body-class="bg-gray-100"  >
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Acumulados</strong>
              </div>
              <b-table striped hover :items="tabelaDetalhes.items" :fields="tabelaDetalhes.fields"></b-table>
            </b-card>

          </b-col>

          <b-col sm="6">
            <b-card body-class="bg-gray-100"  >
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Produtos Beneficiados</strong>
                <div class="card-alinha">
                </div>
              </div>
              <b-row>
                <b-col  sm="12">

                  <b-table striped hover :items="tabelaAnimais.items" :fields="tabelaAnimais.fields">

                  </b-table>

                </b-col>
              </b-row>
            </b-card>
          </b-col>  
          
        </b-row>  
      </div>
    </div>
    
    <!--/.row-->
    <b-card :no-body="true" body-class="bg-gray-100 ">
          <div slot="header" >
            <i class='fa'></i>
            <div class="card-alinha">
              <b-button variant="outline-info"  type="button" @click="$router.go(-1)" > 
                  <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
              
              
            </div>
          </div>
    </b-card>
  </div>
  
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import OrdemAbateFechadaPesquisa from '../../pesquisa/OrdemAbateFechadaPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'

export default {
  components: {
    VueButtonSpinner,
    FuncionarioPesquisa,
    VueAutonumeric,
    CentroEstoquePesquisa,
    OrdemAbateFechadaPesquisa,
    ProdutoPesquisa
  },
  data () {
    return {
      isLoading: false,
      status: '',
      submmited: false,
      monitoraAlteracao: false,
      registroMonitoramento: [],
      itensForamAlterados: false,
      registro: {
        ID                : null,
        BALANCEIRO_ID     : null,
        DATA              : null,
        DT_LANCAMENTO     : null,
        USUARIO           : null,
        DT_ALTERACAO      : null,
        USUARIO_ALTERACAO : null,
        OBS               : null,
        STATUS            : null,
        CENTRO_ESTOQUE_ID : null,
        OP_TIPO           : null,
        ABATE_ID          : null
      },
      animal: {
        ID: null,
        INDICE: null,
        ABATE_RESUMO_ID: null,
        PRODUTO_ID : null,
        QUANT: 0.00,
        PECAS: null,
        VALIDADE: null,
        DATA_VALIDADE: null,
        OP_MANUAL: null,
        OP_STATUS: null
      },
      tipoFechamento: [
        {value: '0', text: '0 - FECHAMENTO DIARIO'},
        {value: '1', text: '1 - FECHAMENTO DO LOTE'}
      ],
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      tabelaAnimais: {
        fields: [
          {
            key: "INDICE",
            label: 'Item'
          },
          {
            key: "DESCRICAO",
            label: 'Produto'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
      tabelaDetalhes: {
        fields: [
          {
            key: "DESCRICAO",
            label: 'Produto'
          },
          {
            key: "PESOS",
            label: 'Itens'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'MEDIA', 
            class:'text-right', 
            label: 'Media (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
         
      optionsRaca: [],
      optionsCor: [],
      optionsSexo: [
       {value: 'M', text: 'MACHO'},
       {value: 'F', text: 'FEMEA'}
      ]
      
    }
  },
  methods: {
    atualizarListaProduto () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getViewPesagem/${this.registro.ID}`)
        .then(result =>{
          this.tabelaAnimais.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaDetalhe () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getViewDetalhe/${this.registro.ID}`)
        .then(result =>{
          this.tabelaDetalhes.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      let reg = await this.getRegistroById(id)
      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
      
      reg.data[0].DATA = moment(new Date(reg.data[0].DATA)).format('YYYY-MM-DD')
      reg.data[0].DT_LANCAMENTO = moment(new Date(reg.data[0].DT_LANCAMENTO)).format('YYYY-MM-DD')
      
      
      this.registro = reg.data[0]
      
      this.tabelaAnimais.items = []

      if (await this.atualizarListaProduto() == true) {
        this.toastCount++
        this.$root.$bvToast.toast(`Resumo da Produção disponível para alterações`, {
          title: 'Atenção',
          autoHideDelay: 2000,
          variant: 'success',
          appendToast: true
        })

      } else {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }

      if (await this.atualizarListaDetalhe() == true) {
        this.toastCount++
        this.$root.$bvToast.toast(`Deatalhes disponíveis`, {
          title: 'Atenção',
          autoHideDelay: 2000,
          variant: 'success',
          appendToast: true
        })

      } else {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
   
      
      this.$store.commit('controle/setAguardando', false)
      return
      
    }
  },
  created () {
    let id = this.$route.params.id
    //ALTERACAO
    if ( id ) {
      this.iniciarAlteracao(id)
      
    } 
    else {
        this.$route.go(-1)
    }
  },
  computed: {
    traduzStatus : function () {
      if (this.registro.STATUS == null) return 'EM LANÇAMENTO'
      switch (this.registro.STATUS) {
        case  '0' : return 'EM LANÇAMENTO'
        case  '1' : return 'FECHADA' 
        case  '2' : return 'EXCLUIDO' 
        default:
          break;
      }
    }
    
  },
  watch: {
  }
}
</script>


<style>
  .card-header .card-alinha {
    position: absolute;
    top: 0;
    right: 0;
    
  }

 .card-header .card-alinha button {
    display: block;
    float: left;
    padding: 0.75rem 1rem;
    margin: 0 !important;
    
    text-align: center;
    
    border: 0;
    border-left: 1px solid #a4b7c1;
    -webkit-box-shadow: 0;
    box-shadow: 0;
 }

</style>


// WEBPACK FOOTER //
// src/views/producao/resumoabate/ResumoAbateDetalhes.vue